export default "__VITE_ASSET__BbQJD$BI__"